<div class="px-6 py-6 flex justify-center border-b border-gray-100">
  <h1 class="text-2xl font-bold text-gray-900">{{ brandConfig.appName }}</h1>
</div>
